var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isOneDay(_vm.start, _vm.end))?_c('span',[_vm._v("\n    "+_vm._s(_vm.dateToString(_vm.start))+"\n")]):_c('span',[_vm._v(_vm._s(_vm.dateRangeToString(_vm.start, _vm.end)))])}
var staticRenderFns = []

export { render, staticRenderFns }